export interface TimezoneSelectOption {
  description: string
  label: string
  searchText: string
  value: string
}

function normalizeSearch(value: string) {
  return value.normalize('NFKC').replaceAll('_', ' ').trim().toLocaleLowerCase()
}

export function filterTimezoneOptions(options: TimezoneSelectOption[], query: string) {
  const terms = normalizeSearch(query).split(/\s+/).filter(Boolean)
  if (terms.length === 0) return options

  return options.filter((option) => {
    const haystack = normalizeSearch(
      `${option.label} ${option.description} ${option.searchText} ${option.value.replaceAll('/', ' ')}`,
    )
    return terms.every((term) => haystack.includes(term))
  })
}
